import { USDS_RESERVE } from "@/components/dashboard/commons"
import { SupplyToEarnReward } from "@renec-foundation/relend-adapter"
import BigNumber from "bignumber.js"
import { ObligationReserveType } from "./dataTypes"

export const getSTERewardInfo = (
  item: ObligationReserveType,
  steTokenPrice: number,
  steReward?: SupplyToEarnReward,
) => {
  const currentTime = Math.floor(Date.now() / 1000)
  const isInEventTime = steReward && steReward.startTime < currentTime && currentTime < steReward.endTime

  const totalSteAccumulatedRewards = (steReward && Number(steReward.totalAccumulatedRewards)) ?? 0
  const totalSteReward = (steReward && Number(steReward.totalRewards)) ?? 0
  const canSteAccumulate = totalSteAccumulatedRewards < totalSteReward

  const shouldDisplaySteAPY = steReward && steReward.apy > 0 && isInEventTime
  const shouldDisplayReward =
    steReward &&
    steReward.reserve !== USDS_RESERVE.address &&
    ((isInEventTime && canSteAccumulate) || !new BigNumber(steReward.accumulatedRewardAmount).isZero())
  const steAPYOnToken = item.price.isZero() ? 0 : ((steReward?.apy ?? 0) * steTokenPrice) / item.price.toNumber()

  return {
    steAPYOnToken,
    shouldDisplaySteAPY,
    shouldDisplayReward,
  }
}
